import {BaseContainerModel} from '../../base-container.model';
import { bl_fi_mst_price_book_event_RowClass } from '../../../dbschema/bl_fi_mst_price_book_event.model';

export class PriceBookEventContainerModel extends BaseContainerModel {
  bl_fi_mst_price_book_event: bl_fi_mst_price_book_event_RowClass = new bl_fi_mst_price_book_event_RowClass();
}
